export const calcDiff = (oldval, newval) => {
  if (oldval === newval)
    return {pos: 0, del: 0, ins: ""};
  let oldChars = [...oldval];
  let newChars = [...newval];
  var commonStart = 0;
  while (oldChars[commonStart] === newChars[commonStart]) {
    commonStart++;
  }
  var commonEnd = 0;
  while (oldChars[oldChars.length - 1 - commonEnd] === newChars[newChars.length - 1 - commonEnd] && commonEnd + commonStart < oldChars.length && commonEnd + commonStart < newChars.length) {
    commonEnd++;
  }
  const del = oldChars.length !== commonStart + commonEnd ? oldChars.length - commonStart - commonEnd : 0;
  const ins = newChars.length !== commonStart + commonEnd ? newChars.slice(commonStart, newChars.length - commonEnd).join("") : "";
  return {
    pos: commonStart,
    del,
    ins
  };
};
let colors = [
  "#9b5de5",
  "#f15bb5",
  "#fee440",
  "#00bbf9",
  "#00f5d4"
];
let colorsFaint = colors.map((c) => c + "33");
export const getEnhancedEntries = (value, rle, doc) => {
  let str = [...value];
  let entries = doc.get_internal_list_entries();
  if (!rle) {
    entries = entries.flatMap((e) => {
      const result = [];
      let left = e.origin_left;
      for (let i = 0; i < Math.abs(e.len); i++) {
        result.push({
          len: 1 * Math.sign(e.len),
          order: e.order + i,
          origin_left: left,
          origin_right: e.origin_right
        });
        left = i;
      }
      return result;
    });
  }
  return entries.map((e, x) => ({
    ...e,
    len: Math.abs(e.len),
    isDeleted: e.len < 0,
    content: e.len > 0 ? str.splice(0, e.len).join("") : "",
    color: colors[x % colors.length],
    originLeft: e.origin_left == 4294967295 ? "ROOT" : e.origin_left,
    originRight: e.origin_right == 4294967295 ? "ROOT" : e.origin_right
  }));
};
